module.exports = __webpack_public_path__ + "static/index/img/baikal-708.1c281402.jpg";